import AppChannel from "../AppChannel";


export default class GridChannel extends AppChannel {
    constructor() {
        super();
        this.reportItems = {}; // key: LIST_COMPANY, value: [{title: "some", report: "report1"}]
    }

    isTargetMode() {
        return this._isTargetMode;
    }

    enableTargetMode() {
        this._isTargetMode = true;
        this.trigger("enableTargetMode");
    }

    disableTargetMode() {
        this._isTargetMode = false;
        this.trigger("disableTargetMode");
    }

    getReportItems(table) {
        return this.reportItems[ table ];
    }

    setReportItems(table, items) {
        this.reportItems[ table ] = items;
        this.trigger("setReportItems", table, items);
    }
}
